

const errorRoutes = [

];

export default errorRoutes;